import application, { definitionsFromContext } from "lib/stimulus"

const context = require.context("./", true, /(.*)controller\.(js|ts)$/)
application.load(definitionsFromContext(context))

import './legacy/guide/component'
import './ui/icon'
